import request from '@/utils/requestData'

// 查询字典数据详细
export function getData(dictCode) {
  return request({
    url: '/otpApi/system/dict/data/' + dictCode,
    method: 'get'
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    const config = {
        url: '/otpApi/system/dict/data/type/' + dictType,
        method: 'get'
    }
    return request(config)
}
